var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup4691(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 26.215,
    height: 34.053,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(-827 -946)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    transform: "translate(827 946)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(876.108 964.166) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    transform: "matrix(0, -1, 1, 0, 0.001, 26.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M14.461,33.564,25.5,24.029a2.024,2.024,0,0,0,.205-2.884,2.173,2.173,0,0,0-2.922-.2L15.173,27.52V2.043a2.07,2.07,0,0,0-4.14,0V27.52L3.422,20.943a2.194,2.194,0,0,0-2.922.2A2.051,2.051,0,0,0,.7,24.029l11.04,9.535a2.132,2.132,0,0,0,2.717,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M21.145,25.715a2.193,2.193,0,0,1-.2-2.922l6.576-7.612H2.043a2.07,2.07,0,0,1,0-4.139H27.52L20.943,3.43a2.171,2.171,0,0,1,.2-2.921,2.024,2.024,0,0,1,2.885.2l9.534,11.04a2.127,2.127,0,0,1,.489,1.335,2.313,2.313,0,0,1-.489,1.381L24.03,25.51a2.088,2.088,0,0,1-1.574.7A1.909,1.909,0,0,1,21.145,25.715Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4691);
export default __webpack_public_path__ + "static/media/Group 469 (1).49e7ac0381486b1f61b56c996efbcda7.svg";
export { ForwardRef as ReactComponent };